// extracted by mini-css-extract-plugin
export default {"hidden":"WinnerArrow_hidden__aULSr","left":"WinnerArrow_left__LI+K5","wrapper":"WinnerArrow_wrapper__ms4cF"};